import { Model } from "@/models/index";

export default class Tag extends Model {
  static type = "tags";
  name!: string;
}
